import * as ko from 'knockout'
import { AllUpViewModel, AllUpViewModelParams } from './AllUpViewModel'
import template from './allup.tpl.html'

if (!ko.components.isRegistered('allup-bettype')) {
  ko.components.register('allup-bettype', {
    viewModel: {
      createViewModel: (params: AllUpViewModelParams) => {
        const viewModel = new AllUpViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
